/* co-home-6 "Reviews" reveal-on-demand.
   Loaded only when the section's "Initially hidden" setting is on. In that mode the section renders
   with .co-home-6--hidden (display:none) and id="reviews". This script:
     - reveals + smooth-scrolls to it when ANY same-page link to #reviews is clicked (the button can
       live in any section on the page — the listener is delegated on document), and
     - reveals + scrolls on load when the page is opened with the #reviews hash (e.g. arriving from a
       "/#reviews" link on another page, where this script isn't loaded).
   On reveal it nudges Flickity.resize(): the carousel was built while display:none, so its cells were
   measured at 0 width. co-flickity's ResizeObserver also self-heals on the width change, but the
   explicit resize makes the layout correct immediately. */
(function () {
  if (window.__coHome6Reveal) return;
  window.__coHome6Reveal = true;

  var HIDDEN = 'co-home-6--hidden';

  function getSection() {
    return document.getElementById('reviews');
  }

  function revealAndScroll(section, smooth) {
    var wasHidden = section.classList.contains(HIDDEN);
    section.classList.remove(HIDDEN);
    /* Wait a frame so the now-visible carousel has a box to measure, then re-lay-out + scroll. */
    requestAnimationFrame(function () {
      if (wasHidden) {
        var carousel = section.querySelector('[data-co-flickity]');
        if (carousel && carousel.__flkty && typeof carousel.__flkty.resize === 'function') {
          carousel.__flkty.resize();
        }
      }
      section.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    });
  }

  /* Reveal when a same-page link to #reviews is clicked. Cross-page links (a different path) are left
     to navigate normally; the destination page reveals via the on-load hash handler below. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hash !== '#reviews') return;
    var samePage = (a.getAttribute('href') || '').charAt(0) === '#' || a.pathname === window.location.pathname;
    if (!samePage) return;
    var section = getSection();
    if (!section) return;
    e.preventDefault();
    if (window.history && history.replaceState) {
      try { history.replaceState(null, '', '#reviews'); } catch (err) { /* ignore */ }
    }
    revealAndScroll(section, true);
  });

  /* Reveal on load if the page opened with the #reviews hash (cross-page arrival). */
  function handleInitialHash() {
    if (window.location.hash !== '#reviews') return;
    var section = getSection();
    if (section) revealAndScroll(section, false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
})();
